import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WishlistEmptyReminderHeaderImage from '../../assets/images/wishlist-empty-reminder-header.png';
import useWishlistEmptyReminder from './useWishlistEmptyReminder';

export default function WishlistEmptyReminderDialog(): React.JSX.Element {
  const { t } = useTranslation(['wishlist', 'common']);
  const { open, onClose, onCtaClick } = useWishlistEmptyReminder();

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle variant="image">
        <Box
          component="img"
          src={WishlistEmptyReminderHeaderImage}
          sx={{
            aspectRatio: '3 / 1',
            objectFit: 'cover',
            width: '100%',
          }}
        />
      </DialogTitle>
      <DialogContent sx={{ py: 1.5 }}>
        <Box sx={{ pt: 1.5, display: 'flex', flexDirection: 'column', gap: 1, textAlign: 'center', px: 3 }}>
          <Typography variant="headlineMedium">
            {t('wishlist:empty_reminder_title')}
          </Typography>
          <Typography variant="bodyMedium">
            {t('wishlist:empty_reminder_description')}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          flexDirection: { xs: 'column-reverse', sm: 'row' },
          '& .MuiButton-root': {
            width: { xs: '100%', sm: 'auto' },
          },
        }}
      >
        <Button variant="text" onClick={onClose}>
          {t('common:close')}
        </Button>
        <Button variant="contained" onClick={onCtaClick}>
          {t('wishlist:empty_reminder_cta')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
